import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { SplashScreenService } from '@core/_base/layout';

/**
 * A tela de abertura — o último seletor do tema velho que o produto ainda usava.
 *
 * Ela sempre foi produto: o `SplashScreenService` é código nosso e a arte é a
 * marca (`assets/marca/`). O que a prendia à árvore vendorizada era só o
 * endereço no disco. A C3 item 6 a promove para o shell próprio e o portão P2
 * chega a zero.
 *
 * Duas coisas saíram na promoção, e as duas eram mortas:
 *  - `LayoutConfigService.getConfig('loader')` alimentava `loaderType`, que
 *    **nenhuma linha do template lia**;
 *  - `ElementRef` do próprio host era injetado e nunca usado — quem o serviço
 *    precisa é o `#splash`, que vem pelo `ViewChild`.
 */
@Component({
  selector: 'mg-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SplashComponent implements OnInit {
  private splashScreenService = inject(SplashScreenService);

  @ViewChild('splash', { static: true }) splash: ElementRef;

  ngOnInit(): void {
    this.splashScreenService.init(this.splash);
  }
}
